import { Helmet } from "react-helmet-async";
import { Button } from "../components/ui/Button";

const pdfPath = "/forroca/transition-bridge-roca-industry-partnership-strategy.pdf";

export function Forroca() {
  return (
    <>
      <Helmet>
        <title>ROCA Industry Partnership Strategy | Transition Bridge</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="Transition Bridge and ROCA Industry Partnership Strategy." />
      </Helmet>

      <section className="bg-bg-primary pt-[calc(var(--header-height)+40px)] pb-[clamp(28px,4vw,40px)]">
        <div className="container-grid max-w-[1120px]">
          <p className="eyebrow mb-4">PARTNERSHIP STRATEGY</p>
          <h1 className="text-balance text-[clamp(1.9rem,4.2vw,3rem)] font-extrabold leading-[1.05]">Transition Bridge &amp; ROCA Industry Partnership Strategy</h1>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Button href={pdfPath} external>Open in new tab</Button>
            <Button variant="secondary" href={pdfPath} download>Download PDF</Button>
          </div>
        </div>
      </section>

      <section className="bg-bg-secondary pb-[clamp(56px,7vw,96px)]">
        <div className="container-grid max-w-[1120px]">
          <div className="overflow-hidden rounded-2xl border border-line bg-surface shadow-soft">
            <iframe
              src={`${pdfPath}#view=FitH`}
              title="Transition Bridge and ROCA Industry Partnership Strategy"
              className="block h-[80vh] min-h-[480px] w-full"
            />
          </div>
          <p className="mt-4 text-sm text-ink-secondary">
            If the document does not display, <a className="font-semibold text-brand-blue underline underline-offset-2" href={pdfPath} target="_blank" rel="noopener noreferrer">open it in a new tab</a> or download it above.
          </p>
        </div>
      </section>
    </>
  );
}
